import React from 'react';
import {DatePicker, TimePicker} from '@mui/x-date-pickers';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFnsV3';
import {LocalizationProvider} from '@mui/x-date-pickers';
import {MenuItem, Select, TextField} from '@mui/material';
import Sliders from "./Sliders";
import HomeStyles from "../../styles/Home.module.css";

const DateTimePicker = ({
                            selectedDate,
                            setSelectedDateMui,
                            selectedTimeMui,
                            setSelectedTimeMui,
                            duration,
                            handleDurationChange,
                            currentLocaDate,
                            maxDate,
                            setSelectedPurpose,
                            selectedPurpose,
                            authenticated,
                            profile,
                            radius,
                            setRadius,
                            altitude,
                            setAltitude,
                            maxAltitude,
                            geometryType,
                            setGeometryType,
                            polygonPoints,
                            onCompletePolygon,
                            onClearPolygon,
                            circleGeoJSON,
                            HomeStyles,
                            polygonError,
                        }) => {

    const allowedValues =
        profile?.faaIDType === "Part 107"
            ? ["Part 107"]
            : profile?.faaIDType === "44809"
                ? ["44809"]
                : ["Part 107", "44809"];
    const selectValue = allowedValues.includes(selectedPurpose) ? selectedPurpose : "";

    return (
        <div className={HomeStyles.date_time_duration_container}>
            <h2 id="detailbar-heading" className={HomeStyles.location}>OPERATION PARAMETERS</h2>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <div>
                    <Sliders
                        radius={radius}
                        setRadius={setRadius}
                        altitude={altitude}
                        setAltitude={setAltitude}
                        maxAltitude={maxAltitude}
                        geometryType={geometryType}
                        setGeometryType={setGeometryType}
                        polygonPoints={polygonPoints}
                        onCompletePolygon={onCompletePolygon}
                        onClearPolygon={onClearPolygon}
                        circleGeoJSON={circleGeoJSON}
                        HomeStyles={HomeStyles}
                        polygonError={polygonError}
                    />
                    <div className={HomeStyles.date_time_duration_div}>
                        <label htmlFor="operation-mode-select" className={HomeStyles.date_time_duration_label}>
                            Operation Mode:
                        </label>
                        <Select
                            id="operation-mode-select"
                            value={selectValue}
                            onChange={(e) => setSelectedPurpose(e.target.value)}
                            className={HomeStyles.select_field}
                            inputProps={{ 'aria-label': 'Operation Mode' }}
                            sx={{
                                height: 36,
                                fontSize: '14px',
                                textAlign: 'left',
                                '& .MuiSelect-select': {
                                    padding: '8px 12px',
                                    textAlign: 'left',
                                },
                                '& .MuiSelect-icon': {
                                    right: 'calc(12px)', // shift 5px to the left from default
                                },
                            }}
                            MenuProps={{
                                PaperProps: {
                                    style: {
                                        fontSize: '14px',
                                    },
                                },
                            }}>
                            {allowedValues.map((val) => (
                                <MenuItem key={val} value={val}>{val}</MenuItem>
                            ))}
                        </Select>

                    </div>
                    <div className={HomeStyles.date_time_duration_div}>
                        <label className={HomeStyles.date_time_duration_label}>
                            Operation Date:</label>
                        <DatePicker
                            slotProps={{
                                textField: {
                                    size: 'small',
                                    sx: {
                                        '& .MuiInputBase-input': {
                                            textAlign: 'left', // This is the correct selector for input text
                                            fontSize: '14px',
                                            padding: '8px 12px', // optional: control padding
                                            cursor: 'pointer', // Safari fix: ensure cursor shows clickable
                                        },
                                        '& .MuiInputBase-root': {
                                            height: 35, // optional: control height
                                        },
                                    },
                                },
                                // Safari fix: ensure proper popper positioning
                                popper: {
                                    sx: {
                                        zIndex: 1300,
                                    },
                                },
                            }}
                            value={selectedDate}
                            className={HomeStyles.input_field}
                            onChange={(newValue) => setSelectedDateMui(newValue)}
                            minDate={currentLocaDate}
                            maxDate={new Date(maxDate)}
                            // Safari fix: force desktop mode for better compatibility
                            desktopModeMediaQuery="@media (pointer: fine)"
                        />
                    </div>
                    <div className={HomeStyles.date_time_duration_div}>
                        <label className={HomeStyles.date_time_duration_label}>
                            Operation Time:</label>
                        <TimePicker
                            slotProps={{
                                textField: {
                                    size: 'small',
                                    sx: {
                                        '& .MuiInputBase-input': {
                                            textAlign: 'left',     // Left-align text
                                            fontSize: '14px',      // Font size in pixels
                                            padding: '8px 12px',   // Optional: adjust padding
                                            cursor: 'pointer',     // Safari fix: ensure cursor shows clickable
                                        },
                                        '& .MuiInputBase-root': {
                                            height: 35,            // Optional: adjust height
                                        },
                                    },
                                },
                                // Safari fix: ensure proper popper positioning
                                popper: {
                                    sx: {
                                        zIndex: 1300,
                                    },
                                },
                            }}
                            value={selectedTimeMui}
                            className={HomeStyles.input_field}
                            minutesStep={1}
                            onChange={(newValue) => {
                                setSelectedTimeMui(newValue);
                            }}
                            ampm={true}
                            // Safari fix: force desktop mode for better compatibility
                            desktopModeMediaQuery="@media (pointer: fine)"
                        />
                    </div>
                    <div className={HomeStyles.date_time_duration_div}>
                        <label className={HomeStyles.date_time_duration_label}>
                            Operation Duration: </label>
                        <Select
                            value={duration}
                            onChange={handleDurationChange}
                            className={HomeStyles.select_field}
                            sx={{
                                height: 36,
                                fontSize: '14px',
                                textAlign: 'left',
                                '& .MuiSelect-select': {
                                    padding: '8px 12px',
                                    textAlign: 'left',
                                },
                                '& .MuiSelect-icon': {
                                    right: 'calc(12px)', // Shift the icon 5px left
                                },
                            }}
                            MenuProps={{
                                PaperProps: {
                                    style: {
                                        fontSize: '14px',
                                    },
                                },
                            }}
                        >
                            {[...Array(12 * 4 + 1)].map((_, i) => {
                                const totalMinutes = (i + 1) * 15;
                                const hours = Math.floor(totalMinutes / 60);
                                const minutes = totalMinutes % 60;
                                const displayText = hours > 0
                                    ? `${hours}hr${minutes > 0 ? ` ${minutes}m` : ''}`
                                    : `${minutes}m`;
                                return (
                                    <MenuItem key={totalMinutes} value={totalMinutes}>
                                        {displayText}
                                    </MenuItem>
                                );
                            }).slice(0, -1)}
                        </Select>

                    </div>
                </div>
            </LocalizationProvider>
        </div>
    );
};

export default DateTimePicker;